// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1XfTs","vLegacy":"SelectSecondary_vLegacy__16i4D","error":"SelectSecondary_error__eodzt","disabled":"SelectSecondary_disabled__XnfHE"};